import {OnDestroy} from "@angular/core";
import {Subscription} from "rxjs";

export class SubscriptionComponent implements OnDestroy {

  private subscriptions: Subscription[] = [];

  constructor() {
  }

  wrapSubscription<T>(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
